export const NAME = 'classes'
